import {
  SR_API_ACTION_PARTNER_GET_BUYERS_AGENT_COMMISSIONS,
} from 'api/actionTypes';

export default async function getPartnerBuyersAgentCommissions(
  { state, apiClient },
  { partnerId, reload }
) {
  const stateRoute = ['partners', 'buyersAgentCommissionsByPartnerId', partnerId];

  if (!reload && state.get(stateRoute)) {
    return state.get(stateRoute);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_BUYERS_AGENT_COMMISSIONS,
    state: state,
    payload: {
      partnerId,
    },
    onSuccess(buyersAgentCommissions) {
      state.set(stateRoute, buyersAgentCommissions);
    },
  });
}
